<template>
  <div>
    <v-select v-model="val" :placeholder="placeholder" :options="options" :label="label" :clearable="false" />
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  mounted() {
    
  },

  data() {
    return {
      val: this.value
    }
  },

  props: {
    value: {
      default() {
        return null
      }
    },

    placeholder: {
      default() {
        return 'Select'
      }
    },

    options: {
      default() {
        return []
      }
    },

    label: {
      default() {
        return 'name'
      }
    }
  },

  watch: {
    val() {
      this.$emit('input', this.val)
    }
  }
}
</script>